import { Component, HostBinding, Input } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';

export type InfoPanelType = 'info' | 'warning' | 'error';

@Component({
    selector: 'app-info-panel',
    templateUrl: './info-panel.component.html',
    styleUrls: ['./info-panel.component.scss'],
    imports: [FlexModule, MatIcon],
})
export class InfoPanelComponent {
    @Input() @HostBinding('class') type: InfoPanelType = 'error';
}
